import { Trans } from '@lingui/macro';
import * as React from 'react';

export const inputNationalRegisterAndBirthdateMismatchErrorMessage = (
  <Trans>
    Les premiers chiffres du numéro de registre national ne correspondent pas à la date de naissance
  </Trans>
);
